import * as React from 'react';
import type { TenantStatus } from '@klareospace/pharos-lib-types';

import { STATUS_BADGE_COLORS } from '../status-badge';
import { StatusBadge } from '../status-badge';

const TENANT_STATUS_STYLES: Record<TenantStatus, string> = {
  active: STATUS_BADGE_COLORS.success,
  archived: STATUS_BADGE_COLORS.neutral,
  draft: STATUS_BADGE_COLORS.info,
  inactive: STATUS_BADGE_COLORS.warning,
  initialization_failed: STATUS_BADGE_COLORS.danger,
  initializing: STATUS_BADGE_COLORS.in_progress,
};

export interface TenantStatusBadgeProps {
  /** The translated label to show inside the badge */
  label: string;
  /** The tenant status to display */
  status: TenantStatus;
}

export function TenantStatusBadge({ label, status }: TenantStatusBadgeProps): React.JSX.Element {
  return <StatusBadge label={label} status={status} styles={TENANT_STATUS_STYLES} />;
}
